// @flow

import React from "react";
import { useDispatch, useSelector } from "react-redux";

import * as atypes from "src/constants/actionTypes";
import { getReportName } from "src/reducers";

import { ReportLinkButton } from "./styles";

type Props = {
  reportId: string,
  color: string,
};

const ReportLink = ({ reportId, color }: Props) => {
  const dispatch = useDispatch();
  const report = useSelector(({ app }) => getReportName(app, reportId));
  if (report) {
    return (
      <ReportLinkButton
        type="button"
        color={color}
        onClick={() => {
          dispatch({
            type: atypes.SET_HOMESCREEN_REPORT_REQUEST,
            payload: {
              id: reportId,
            },
          });
        }}
      >
        {report}
      </ReportLinkButton>
    );
  }
  return null;
};

export default ReportLink;
